///<reference path="../../employee/sections/employee.notes.section.ts"/>
module Meevo.Plugins.Student {
    "use strict";
    /**
    * Motes Section of Employee 
    */
    export class NotesSection extends Meevo.Plugins.Employee.NotesSection {
        public get auditNounForSave() {
            return Model.NounEnum.StudentNote;
        }
    }
}